export default __webpack_public_path__ + "static/media/motorbike.b51f4e33.svg";